var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iframe',{attrs:{"width":_vm.width,"height":_vm.height,"src":_vm.embedUrl,"frameborder":"0","allow":"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":_vm.allowFullscreen}})
}
var staticRenderFns = []

export { render, staticRenderFns }